module.exports = __webpack_public_path__ + "static/media/general-commonAreasArea.5fde6a0a.png";